export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0052.6ee5fc70.webp";